// 菜单 顶栏
export default [
  { path: '/index', title: '首页', icon: 'home' }
  // {
  //   path: '/demo',
  //   title: '小程序商城管理',
  //   icon: 'folder-o'
  // }
]
